import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'authImage'
})
export class AuthImagePipe implements PipeTransform {

	constructor (
		private httpClient: HttpClient,
	) {
	}

	async transform(src: string | undefined, ...args: unknown[]): Promise<string> {
		try {
			const imageBlob = await this.httpClient.get(src ?? '', { responseType: 'blob' }).toPromise();
			const reader = new FileReader();
			return new Promise((resolve, reject) => {
				reader.onloadend = () => resolve(reader.result as string);
				reader.readAsDataURL(<Blob>imageBlob);
			});
		} catch (e) {
			return 'assets/images/material-not-found-thumbnail.png';
		}
	}
}

